import { Component, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import {
  MsalService
} from '@azure/msal-angular';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';
import { SpeedDialModule } from 'primeng/speeddial';
import { SplitButtonModule } from 'primeng/splitbutton';
import { environment } from '../../../environments/environment';
import { MainMenuComponent } from '../../components/shared/main-menu/main-menu.component';
@Component({
  selector: 'app-home',
  standalone: true,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  imports: [
    SidebarModule,
    ButtonModule,
    SplitButtonModule,
    SpeedDialModule,
    AvatarModule,
    AvatarGroupModule,
    MainMenuComponent,
    CommonModule,
  ],
})
export class HomeComponent implements OnInit {
  userRoles: any[] = [];
  items: any = {};
  menuRol: any[] = [];
  constructor(private authService: MsalService) {}
  ngOnInit(): void {
    this.checkAndSetActiveAccount();

  }

  checkAndSetActiveAccount(){
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }

    this.userRoles = this.authService.instance.getActiveAccount()?.idTokenClaims?.roles || [];
    this.buildMenu();  
    this.loadMenuByUserRole();
  }

  buildMenu() {
    this.items = {
      [environment.roles.gestionRole]: {
        title: 'Gestión Vinculaciones',
        class: 'pi pi-id-card text-4xl text-green-500',
        description:
          'Este módulo te permite gestionar solicitudes de vinculación, realizar vinculaciones, gestionar informes y más!',
        routerLink: '/gestor',
      },

      [environment.roles.adminRole]: {
        title: 'Configuración Plataforma',
        class: 'pi pi-sitemap text-4xl text-green-500',
        description:
          'Este módulo te permite realizar la administración de las configuraciones generales de la plataforma!',
        routerLink: '/admin',
      },

      [environment.roles.gestionEventosRole]: {
        title: 'Gestión Eventos',
        class: 'pi pi-calendar text-4xl text-green-500',
        description:
          'Este módulo te permite realizar la creación y gestión de eventos de la plataforma!',
        routerLink: '/event-gestor',
      },
      [environment.roles.financialGestorRole]: {
        title: 'Gestión Financiera',
        class: 'pi pi-money-bill text-4xl text-green-500',
        description:
          'Este módulo te permite realizar la gestión de pagos para los eventos y vinculaciones registradas en plataforma',
        routerLink: '/financial-gestor',
      },
      [environment.roles.checkerRole]: {
        title: 'Gestión de Accesos',
        class: 'pi pi-sign-in text-4xl text-green-500',
        description:
          'Este módulo te permite realizar la gestión de los ingresos de los alumnos a las clases',
        routerLink: '/checker',
      },
    };
  }

  loadMenuByUserRole() {
    for (let rol of this.userRoles) {
      if(this.items[rol]){
        this.menuRol?.push(this.items[rol]);
      }
    }
  }
}
